import React from 'react'

export const categoryList = t => [
	{
		Header: <span className='sort-icons'>{t('category_section.fields.position')}</span>,
		accessor: 'position',
		width: 90,
		Cell: ({ original, value }) => <span style={{ color: original?.isActive ? 'unset' : 'lightgray' }}>{value}</span>
	}, {
		Header: t('common.fields.name'),
		accessor: 'name',
		Cell: ({ original, value }) => <span style={{ color: original?.isActive ? 'unset' : 'lightgray' }}>{value}</span>
	}
]

export const productGrid = t => [
	{
		Header: t('common.fields.code'),
		accessor: 'code'
	}, {
		Header: t('common.fields.name'),
		accessor: 'name'
	}
]

export const selectTemplate = t => [
	{
		Header: t('category_section.fields.code'),
		accessor: 'code'
	}, {
		Header: t('common.fields.name'),
		accessor: 'name'
	}
]
